<template>
  <div class="step-content">
    <v-card 
      outlined
      color="transparent"
      class="faq text-left mx-n4 my-8 mt-12"
    >
      <v-list 
        flat
        color="transparent"
        class="py-0"
      >
        <v-list-item
          class="faq-item py-2"
        >
          <v-list-item-icon class="mr-4">
            <v-icon color="primary">{{ icons.mdiInformationOutline }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-medium">
              {{ $t('signup.steps.REA.orientations.title') }}
            </v-list-item-title>
            <v-list-item-subtitle class="item-subtitle mt-2">
              {{ $t('signup.steps.REA.orientations.text') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="(faq, key) in faqList"
          :key="key"
          class="faq-item py-1 secondary--text"
          @click="toggleHelp(true, 'activation', faq.section, faq.item)"
        >
          <v-list-item-title v-text="faqTitle(faq)" />
        </v-list-item>
      </v-list>
      <!-- <v-divider class="mt-0" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="toggleHelp(true, 'activation')"
        >
          Ver mais
        </v-btn>
      </v-card-actions> -->
    </v-card>

    <referral-card 
      :user="user"
      @help="toggleHelp"
    />

    <slot name="quick-access" />

    <v-btn 
      text
      small
      class="help-btn mt-4"
      color="grey"
      @click="toggleHelp(true, 'signup')"
    >
      <v-icon
        small
        class="mr-4"
      >
        {{ icons.mdiHelpCircleOutline }}
      </v-icon>
      {{ $t('general.need_help') }}
    </v-btn>
  </div>
</template>

<style>

  .step-content .item-title {
    margin: 6px 0;
  }

  .step-content .item-subtitle {
    line-height: 1.4;
    text-overflow: initial;
    white-space: initial;
  }

  .step-content .calendar {
    max-width: initial;
  }
  .step-content .faq {
    max-width: initial;
    border-color: var(--v-grey-darken3) !important;
  }

  .step-content .faq .faq-item:not(:last-child) {
    border-bottom: 1px solid var(--v-grey-darken3) !important;
  }

</style>

<script>

  // Icons
  import {
    mdiHelpCircleOutline,
    mdiInformationOutline,
    mdiClose,
    mdiCalendarAlert,
    mdiCheck
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { sync, get } from 'vuex-pathify'
  import _ from 'lodash';


  export default {
    name: 'Step4',

    props: {
      step: {
        type: Object,
        default: () => {}
      },
      appURL: {
        type: String,
        default: ''
      },
      helpContent: {
        type: Object,
        default: () => {}
      },
      refresh: {
        type: Boolean,
        default: false
      }
    },

    components: {
      ReferralCard: () => import('@/components/ReferralCard'),
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiHelpCircleOutline,
        mdiInformationOutline,
        mdiClose,
        mdiCalendarAlert,
        mdiCheck
      },
      faq: [
        {
          section: 'signup',
          item: 3,
        },
        {
          section: 'manual',
          item: null,
        },
      ],
    }),

    computed: {
      profileView: sync('app/views@profile'),
      user: sync('user'),
      status: sync('user/status'),
      toast: sync('app/toast'),
      help: sync('app/views@help'),
      help_sections: sync('help/sections'),

      stepName () {
        return this.$options.name.toLowerCase();
      },

      faqList () {
        const faq = this.faq;
        const help = this.helpContent;
        const list = _.reduce(faq, (list, item) => {
          if (item.section in help && (item.item == null || (help[item.section].items && item.item in help[item.section].items))) {
            list.push(item);
          }
          return list;
        }, []);
        return list
      },

    },

    watch: {
      refresh (b) {
        if (b) this.$emit('onRefresh');
      }
    },

    methods: {
      ...services,

      faqTitle (faq) {
        const help = this.helpContent;
        if (!help || !faq) return '';
        const section = help[faq.section];
        if (!section) return '';
        if (faq.item == null) {
          return (section.title != null) ? section.title : '';
        }
        if (!section.items) return '';
        const item = section.items[faq.item];
        return (item && item.title) ? item.title : '';
      },

      openLocation (uri, target) {
        window.open(uri, target);
      },

      actionCalled () {
      },

      updateView () {

      },

    },

    created () {
    },

    mounted () {
    },

    directives: {
    },

  }
</script>
